import {SvgIcon} from '@mui/material';
import MainLinearGradient from './MainLinearGradient';

export default function SignupIcon() {
	return (
		<SvgIcon width="32" height="32" viewBox="0 0 32 32" fill="none">
			<g id="Icon">
				<g id="vuesax/bulk/login">
					<g id="login">
						<path id="Vector" opacity="0.4"
						      d="M12 9.59996V22.3866C12 26.6666 14.6667 29.3333 18.9333 29.3333H22.3867C26.6533 29.3333 29.32 26.6666 29.32 22.4V9.59996C29.3333 5.33329 26.6667 2.66663 22.4 2.66663H18.9333C14.6667 2.66663 12 5.33329 12 9.59996Z"
						      fill="url(#paint0_linear_2116_1495)"/>
						<path id="Vector_2"
						      d="M16.5727 10.8266L21.0393 15.2933C21.426 15.6799 21.426 16.3199 21.0393 16.7066L16.5727 21.1733C16.186 21.5599 15.546 21.5599 15.1593 21.1733C14.7727 20.7866 14.7727 20.1466 15.1593 19.7599L17.9193 16.9999H3.66602C3.11935 16.9999 2.66602 16.5466 2.66602 15.9999C2.66602 15.4533 3.11935 14.9999 3.66602 14.9999H17.9193L15.1593 12.2399C14.9593 12.0399 14.866 11.7866 14.866 11.5333C14.866 11.2799 14.9593 11.0266 15.1593 10.8266C15.546 10.4266 16.1727 10.4266 16.5727 10.8266Z"
						      fill="url(#paint1_linear_2116_1495)"/>
					</g>
				</g>
			</g>
			<defs>
				<linearGradient id="paint0_linear_2116_1495" x1="28.9504" y1="2.66663" x2="11.1426" y2="3.25203"
				                gradientUnits="userSpaceOnUse">
					<MainLinearGradient/>
				</linearGradient>
				<linearGradient id="paint1_linear_2116_1495" x1="20.931" y1="10.5266" x2="1.86364" y2="12.1735"
				                gradientUnits="userSpaceOnUse">
					<MainLinearGradient/>
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
